import * as React from 'react';
export const refundSvg = React.forwardRef(function refundSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M3.501.79a.75.75 0 1 1 1.06 1.06l-1.9 1.9h5.312c2.062.002 3.933 1.57 3.933 3.75 0 2.124-1.813 3.938-3.937 3.938a.75.75 0 0 1 0-1.5c1.295 0 2.437-1.142 2.437-2.438 0-1.16-.95-2.122-2.186-2.238l-.251-.012h-5.32l1.912 1.906a.75.75 0 1 1-1.059 1.062L.314 5.039a.752.752 0 0 1 0-1.061L3.5.79Z',
    }),
  );
});
refundSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var refund = {
  category: 'icon',
  colorable: true,
  name: 'refund',
  svg: refundSvg,
};
